module.exports = __webpack_public_path__ + "img/icon-warning-forestfire-red.3cfa5c80.svg";